import {FC} from 'react';
import {ImportDevices} from '../../components/Settings';

const ImportDeivesPage: FC = () => {
  return (
    <div>
      <ImportDevices />
    </div>
  );
};

export default ImportDeivesPage;
